(() => {
	const PaymentSchedulesController = (
		$scope,
		$rootScope,
		$http,
		$q,
		$location,
		messageService,
		validationService,
		userService,
		paymentSchedulesDataService,
		accountService,
		settingsService,
		emailService
	) => {
		$scope.$on('$viewContentLoaded', () => {
			$scope.isSaveReminderSpinnningWheelActive = false;
			$scope.isSavePaymentSpinnningWheelActive = false;
			$scope.button_disable = false;
			$scope.editedPaymentSchedule = null;
			$scope.deletablePaymentSchedule = {};
			$scope.payments = [];
			$scope.delIndex = -1;
			$scope.modalTitle = '';
			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage
					? $rootScope.paginationPerPage
					: 25,
				pageOrder: {
					predicate: 'name',
					reverse: false
				},
				search: null
			};
			$scope.reminder = {};
			$scope.customizedLabels = {};
			getUser();
			getInvoiceReminder();
			getPaymentReceipt();

			getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
		});

		function getUser() {
			$scope.userObservable = accountService.getUserWeb().subscribe(user => {
				if (user !== null && typeof user !== 'undefined') {
					$scope.currencyCode = user.currency.currencyCode;
					settingsService.customizeLabelsObservable.subscribe(data => {
						$scope.customizedLabels = data;
						paymentSchedulesDataService
							.getPaymentScheduleOptions()
							.subscribe(
								data => getPaymentScheduleOptionsSuccessCallback(data),
								err => getPaymentScheduleOptionsErrorCallback(err)
							);
					});
				}
			});
		}
		function getPaymentScheduleOptionsSuccessCallback(data) {
			if (!data) {
				console.error('No data for payment schedule options');
				return;
			}
			$scope.payments.push({
				amount: '',
				type: ''
			});

			const {
				paymentScheduleTypes,
				dateItemsTypes,
				jobDateDependingTypes,
				indexOfOnJobDate,
				indexOfOnInvoiceDate
			} = data;
			$scope.paymentScheduleTypes = configPaymentScheduleTypes(
				paymentScheduleTypes
			);
			$scope.payments[0].type = paymentScheduleTypes[0];
			$scope.dateItemsTypes = dateItemsTypes;
			$scope.payments[0].dateItemsType = dateItemsTypes[0];
			$scope.jobDateDependingTypes = configPaymentScheduleJobDependingTypes(
				jobDateDependingTypes
			);
			$scope.indexOfOnJobDate = indexOfOnJobDate;
			$scope.indexOfOnInvoiceDate = indexOfOnInvoiceDate;
			$scope.paymentsModel = angular.copy($scope.payments);
		}

		function configPaymentScheduleJobDependingTypes(jobDependingTypes) {
			return jobDependingTypes.map(el => setCorrectNaming(el));
		}

		function setCorrectNaming(el) {
			const res = { id: el, name: '' };
			if (el.includes('main shoot')) {
				res.name = el.replace(
					'main shoot',
					$scope.customizedLabels.mainShootLabel.toLowerCase()
				);
			} else if (el.includes('invoice date')) {
				res.name = el.replace('invoice date', 'quote or invoice created date');
			} else {
				res.name = el;
			}
			return res;
		}

		function configPaymentScheduleTypes(types) {
			const typesObjArray = [];
			types.forEach(type => {
				typesObjArray.push({
					name: type === 'Dollars' ? $scope.currencyCode : type,
					key: type
				});
			});

			return typesObjArray;
		}

		function getPaymentScheduleOptionsErrorCallback() {
			toastr.error('No available payment types', 'Error');
		}

		function getInvoiceReminder() {
			$http
				.get('/protected/rest/invoice_reminder/get')
				.then(result => {
					if (result.data) {
						$scope.reminder = result.data;
					} else {
						$q.reject(result);
					}
				})
				.catch(messageService.showDefaultErrorMessage);
		}

		function getPaymentReceipt() {
			$http
				.get('/protected/rest/payment-receipt/settings/get')
				.then(result => {
					if (result.data) {
						$scope.paymentReceipt = result.data;
					} else {
						$q.reject(result);
					}
				})
				.catch(messageService.showDefaultErrorMessage);
		}

		$scope.saveReminder = function() {
			if (
				$scope.reminder.beforeDueDate &&
				$scope.reminder.daysBeforeDueDate == null
			) {
				messageService.showToaster('e_3', 'generalValidation');
			} else if (
				$scope.reminder.afterDueDate &&
				$scope.reminder.daysAfterDueDate == null
			) {
				messageService.showToaster('e_3', 'generalValidation');
			} else if (
				$scope.reminder.afterDueDate &&
				$scope.reminder.daysRegularlyAfterDueDate == null
			) {
				messageService.showToaster('e_3', 'generalValidation');
			} else if (!emailService.isSubjectValid($scope.reminder.emailSubject)) {
			} else {
				$scope.isSaveReminderSpinnningWheelActive = true;
				$scope.reminder.emailText = $rootScope.addMaiStyling(
					$scope.reminder.emailText
				);

				$http({
					url: '/protected/rest/invoice_reminder/save',
					method: 'POST',
					data: $scope.reminder
				}).then(
					result => {
						if (result.data.message || result.status === 204) {
							messageService.showToaster('s_1', 'paymentSchedules');
						} else if (result.data.errorMessage) {
							messageService.showToaster('e_2', 'paymentSchedules');
						} else {
							messageService.showToaster('e_0', 'general');
						}
						$scope.isSaveReminderSpinnningWheelActive = false;
					},
					result => {
						$scope.isSaveReminderSpinnningWheelActive = false;

						const { errorTitle, errorMessage } = result.data;
						if (errorTitle && errorMessage) {
							return messageService.showErrorFromBackend(
								errorTitle,
								errorMessage
							);
						}
						if (result.status === 422) {
							const path = $location.path();
							if (path.indexOf('payment_schedules') !== -1) {
								return messageService.showToaster('e_0', 'paymentSchedules');
							}

							return messageService.showToaster('e_0', 'general');
						}
						return messageService.showToaster('e_0', 'general');
					}
				);
			}
		};

		$scope.savePaymentReceipt = function() {
			if (!emailService.isSubjectValid($scope.paymentReceipt.emailSubject)) {
				return;
			}

			$scope.paymentReceipt.emailText = $rootScope.addMaiStyling(
				$scope.paymentReceipt.emailText
			);
			$scope.isSavePaymentSpinnningWheelActive = true;

			$http({
				url: '/protected/rest/payment-receipt/settings/save',
				method: 'POST',
				data: $scope.paymentReceipt
			})
				.then(successSaveReceipt)
				.catch(errorSaveReceipt)
				.finally(() => {
					$scope.isSavePaymentSpinnningWheelActive = false;
				});

			function successSaveReceipt() {
				messageService.showToaster('s_4', 'paymentSchedules');
			}
		};

		function errorSaveReceipt({ status, data }) {
			const { errorTitle, errorMessage } = data;
			let errorCode, errorPlace, value;

			if (status >= 400 && status < 500 && data.errorMessage) {
				if (
					data.errorMessage.includes(
						"You're trying to save the Receipt of payment email template without a invoice link!"
					)
				) {
					errorCode = 'e_4';
					errorPlace = 'emailTemplate';
				} else if (errorTitle) {
					messageService.showErrorFromBackend(errorTitle, errorMessage);
					return;
				} else {
					errorCode = 'e_2';
					errorPlace = 'general';
					value = data.errorMessage;
				}
			} else {
				errorCode = 'e_0';
				errorPlace = 'general';
			}
			messageService.showToaster(errorCode, errorPlace, value);
		}

		$scope.addPayment = function() {
			$scope.payments.push({
				jobDateDepending: $scope.jobDateDependingTypes[0].id,
				dateItemsType: $scope.dateItemsTypes[0],
				type: $scope.paymentScheduleTypes[0].key
			});
		};

		$scope.addSubjectVariable = function($event, id, type) {
			const el = document.getElementById(id);
			const subject = emailService.addSubjectVariable(el, $event);
			if (type === 'RECEIPT') {
				$scope.paymentReceipt.emailSubject = subject;
			}
			if (type === 'REMINDER') {
				$scope.reminder.emailSubject = subject;
			}
		};

		$scope.clearForm = function() {
			$scope.name = '';
			$scope.payments = [
				{
					amount: null,
					dateItemsType: $scope.dateItemsTypes[0],
					jobDateDepending: $scope.jobDateDependingTypes[0].id,
					type: $scope.paymentScheduleTypes[0].key
				}
			];
		};

		$scope.addPaymentSchedule = function() {
			$scope.modalTitle = 'New';
			$scope.editedPaymentSchedule = null;
			$('#paymentScheduleModal').modal('show');
		};

		$scope.breadcrumbs = [
			{ link: '/', title: 'Dashboard' },
			{ link: '/settings', title: 'Settings' },
			{ link: null, title: 'Invoice & Payment Settings' }
		];

		$scope.duplicatePaymentSchedule = function(index) {
			getPaymentSchedule($scope.paymentSchedules[index].id, data => {
				$scope.modalTitle = 'New';
				$scope.editedPaymentSchedule = data;
				$('#paymentScheduleModal').modal('show');
			});
		};

		$scope.editPaymentSchedule = function(index) {
			$.blockUI();
			$http
				.get(
					`/api/user/settings/payment-schedules/${
						$scope.paymentSchedules[index].id
					}`
				)
				.then(result => {
					$.unblockUI();
					if (result.data.data) {
						$scope.modalTitle = 'Edit';
						// angular.copy(result.data, $scope.editedPaymentSchedule);
						$scope.editedPaymentSchedule = result.data.data;
						$('#paymentScheduleModal').modal('show');
					} else {
						// toastr["error"]("Failed request to server", 'Error');
						messageService.showToaster('e_0', 'general');
					}
				});
		};

		$scope.addPaymentToEdited = function() {
			if (!$scope.editedPaymentSchedule.paymentSchedulePartDTOs) {
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs = [];
			}
			$scope.editedPaymentSchedule.paymentSchedulePartDTOs.push({
				jobDateDepending: $scope.jobDateDependingTypes[0].id,
				dateItemsType: $scope.dateItemsTypes[0],
				type: $scope.paymentScheduleTypes[0].key
			});
		};

		$scope.paymentScheduleSuccessCallback = function(response) {
			if (response) {
				if (response.data) {
					$('#paymentScheduleModal').modal('hide');
					delete $rootScope.error;
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				} else {
					$rootScope.error = true;
					$rootScope.error_message = response.result;
				}
			}
			$scope.button_disable = false;
		};

		$scope.paymentScheduleErrorCallback = function() {
			$rootScope.authenticated = false;
			$rootScope.error = true;
			$rootScope.error_message = 'Failed request to server';
		};

		$scope.showDeleteWindow = function(index) {
			angular.copy(
				$scope.paymentSchedules[index],
				$scope.deletablePaymentSchedule
			);
			$scope.delIndex = index;
		};

		$scope.deleteEditedPaymentPart = function(index) {
			if ($scope.editedPaymentSchedule.paymentSchedulePartDTOs[index].id) {
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs[
					index
				].isDeleted = true;
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs[index].amount = 0;
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs[
					index
				].dateItemsAmount = 0;
			} else {
				$scope.editedPaymentSchedule.paymentSchedulePartDTOs.splice(index, 1);
			}
		};
		$scope.deleteNewPaymentPart = function(index) {
			$scope.payments.splice(index, 1);
		};

		function paymentScheduleDeletingSuccessCallback(data) {
			if (data) {
				if (data.success) {
					delete $rootScope.error;
					// toastr["success"](data.message, 'Success');
					// $scope.deletablePaymentSchedule
					messageService.showToaster(
						's_2',
						'paymentSchedules',
						$scope.deletablePaymentSchedule.name
					);
					$scope.paymentSchedules.splice($scope.delIndex, 1);
					$scope.button_disable = false;
					getResultsPage($scope.pageRequest.page, $scope.pageRequest.perPage);
				} else {
					messageService.handleError({ error: data });
					$scope.button_disable = false;
				}
			}
			$scope.button_disable = false;
		}

		function paymentScheduleDeletingErrorCallback() {
			$rootScope.authenticated = false;
			$rootScope.error = true;
			$rootScope.error_message = 'Failed request to server';
			// toastr["error"]("Failed request to server", 'Error');
			messageService.showToaster('e_0', 'general');
			$scope.button_disable = false;
		}

		$scope.deletePaymentSchedule = function() {
			$scope.button_disable = true;
			$('#deletePaymentScheduleModal').modal('hide');

			paymentSchedulesDataService
				.deletePaymentSchedule($scope.deletablePaymentSchedule)
				.subscribe(
					data => paymentScheduleDeletingSuccessCallback(data),
					err => paymentScheduleDeletingErrorCallback(err)
				);
		};

		function getPaymentSchedule(id, outObject) {
			$http.get(`/api/user/settings/payment-schedules/${id}`).then(result => {
				$.unblockUI();
				if (result.data.data) {
					outObject(result.data.data);
				} else {
					// toastr["error"]("Failed request to server", 'Error');
					messageService.showToaster('e_0', 'general');
				}
			});
		}

		function getResultsPage(pageNumber, perPage, predicate, reverse) {
			let changed = false;
			if (
				typeof predicate !== 'undefined' &&
				predicate != null &&
				typeof reverse !== 'undefined' &&
				reverse != null
			) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (typeof perPage !== 'undefined' && perPage != null) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}
			if (typeof pageNumber !== 'undefined' && pageNumber != null) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if (
				$scope.pageRequest &&
				$scope.totalItems != 0 &&
				$scope.totalItems <
					($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1
			) {
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				$http
					.get(
						`/protected/rest/company_payment_schedules?perPage=${
							$scope.pageRequest.perPage
						}&page=${$scope.pageRequest.page}&predicate=${
							$scope.pageRequest.pageOrder.predicate
						}&reverse=${$scope.pageRequest.pageOrder.reverse}`
					)
					.then(result => {
						if (result.data && result.data.pageRequest) {
							$scope.pageRequest = result.data.pageRequest;
						}
						$scope.pageNumbers = [];
						$scope.totalItems = result.data.total;
						let pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
						pagesCount = Math.ceil(pagesCount);
						for (let i = 1; i <= pagesCount; i++) {
							$scope.pageNumbers[i - 1] = i;
						}
						$scope.paymentSchedules = result.data.results;
					});
			}
		}

		$scope.order = function(predicate) {
			$scope.pageRequest.pageOrder.reverse =
				$scope.pageRequest.pageOrder.predicate === predicate
					? !$scope.pageRequest.pageOrder.reverse
					: false;
			getResultsPage(
				null,
				null,
				predicate,
				$scope.pageRequest.pageOrder.reverse
			);
		};

		$scope.getCurrentPage = function() {
			return $scope.pageRequest.page;
		};
		$scope.perPageChanged = function(newPerPage) {
			getResultsPage(null, newPerPage);
			$rootScope.paginationPerPage = newPerPage;
		};
		$scope.goToPage = function(newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null);
			}
		};
		$scope.jumpBack = function(disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null);
				}
			}
		};
		$scope.jumpAhead = disabled => {
			if (!disabled) {
				if (
					$scope.totalItems >=
					$scope.pageRequest.page * $scope.pageRequest.perPage + 1
				) {
					getResultsPage($scope.pageRequest.page + 1, null);
				}
			}
		};

		$scope.disableDragDrop = () => true;
	};

	angular
		.module('main')
		.controller('PaymentSchedulesController', PaymentSchedulesController);

	PaymentSchedulesController.$inject = [
		'$scope',
		'$rootScope',
		'$http',
		'$q',
		'$location',
		'messageService',
		'validationService',
		'userService',
		'paymentSchedulesDataService',
		'accountService',
		'settingsService',
		'emailService'
	];
})();



// WEBPACK FOOTER //
// ./web/js/controllers/settings/paymentSchedulesControllers.js